import React from 'react';;


const ItemScores = (props) => {
    return (
        <div className="getScore">
            <span className="title">{props.title}</span>
            <span className="title">{props.date}</span>
            <span className="title">
                {props.lose ? 'امتیاز خرج شده' : 'امتیاز کسب شده'}
                <i className="icon-black-star-silhouette"></i>
                <b>{props.grade}</b>
            </span>
            {props.lose ?
                <i className="icon-down-arrow-not-true icon"></i>
                :
                <i className="icon-down-arrow-true icon"></i>
            }
        </div>
    );
}

export default ItemScores;